import { render, staticRenderFns } from "./evidence-info.vue?vue&type=template&id=369e83ce&scoped=true&"
import script from "./evidence-info.vue?vue&type=script&lang=js&"
export * from "./evidence-info.vue?vue&type=script&lang=js&"
import style0 from "./evidence-info.vue?vue&type=style&index=0&id=369e83ce&prod&lang=less&"
import style1 from "./evidence-info.vue?vue&type=style&index=1&id=369e83ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369e83ce",
  null
  
)

export default component.exports